import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ImageResponseGet } from '../../../../../models/api-dam/image/image-response.model';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProductServiceService } from '../../../../../services/api-store/product-service/product-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ImmaginiCreateComponent } from '../../../dam/immagini/immagini-create/immagini-create.component';
import { LoadImageFromDamComponent } from '../../../../../components/ui/load-image-from-dam/load-image-from-dam.component';
import { ProductServiceRequest, ProductServiceUrlClickAndCollectType } from '../../../../../models/api-store/product-service/product-service.request.model';
import { ImageService } from '../../../../../services/api-dam/image/image.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { UtilsService } from '../../../../../services/utils-folder/utils.service';
import { DocumentService } from '../../../../../services/api-dam/document/document.service';
import { DocumentRequestSearch } from '../../../../../models/api-dam/document/document-request.model';
import { CTAURLResourceEnum } from '../../../../../models/cta.resource';
import { DIALOG_LARGE_CONFIG } from '../../../../../utils/config/modal-settings';
import { LOADINGIMAGE } from '../../../../../utils/config/image-settings';
import { FALSE, TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-prodotti-create',
  templateUrl: './prodotti-create.component.html'
})
export class ProdottiCreateComponent {

  formBuilder: FormGroup;
  request: any = {};
  goBackUrl: string = "/store/prodotti";
  imageChoice: ImageResponseGet = new ImageResponseGet();
  visibleImageChoice: boolean = false;
  isButtonSaveDisabled: boolean = false;
  ckeConfig: any;
  serviceDescriptionValue: string;
  dataSheetValue: string;
  offerInformationValue: string;
  legalNoticeValue: string;
  @ViewChild("ckeditor") ckeditor: any;
  initialDocumentValue = new FormControl('');
  subscription: any;

  errorMsg_documentIds: string = "Non sono presenti documenti...";
  urlClickAndCollectType = ProductServiceUrlClickAndCollectType;
  ctaUrl = CTAURLResourceEnum;
  urlClickAndCollectTypeList = [];

  constructor(
    private router: Router,
    private productServiceService: ProductServiceService,
    private imageService: ImageService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private utilsService: UtilsService,
    private documentService: DocumentService,

  ) {
    this.ckeConfig = this.utilsService.configCkeditor;
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.urlClickAndCollectTypeList = this.urlClickAndCollectTypeKeys();
    this.initForm();
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  urlClickAndCollectTypeKeys(): Array<any> {
    const keys = Object.keys(this.urlClickAndCollectType);
    let res = [];
    for (let obj of keys) {
      res.push({
        value: obj,
        label: obj.replace("_", " ")
      });
    }
    return res;
  }

  changeUrlClickAndCollectType() {
    let value = "";
    if (this.formBuilder.controls['urlClickAndCollectType'].value != "") {
      value = this.ctaUrl[this.formBuilder.controls['urlClickAndCollectType'].value];
    }
    this.formBuilder.controls['urlBookAndCollect'].setValue(value);
  }

  initForm() {
    this.serviceDescriptionValue = '';
    this.dataSheetValue = '';
    this.offerInformationValue = '';
    this.legalNoticeValue = '';
    this.formBuilder = this.fb.group({
      index: [0],
      type: ["PRODOTTO"],
      serviceName: ["", Validators.required],
      analyticsCode: [""],
      serviceDescription: [""],
      expirationTime: [""],
      expirationDay: [Date],
      startTime: [""],
      startDay: [Date],
      landingPageType: [""],
      landingPageService: [""],
      dataSheet: [""],
      offerInformation: [""],
      urlBookAndCollect: [""],
      urlClickAndCollectType: [""],
      legalNotice: [""],
      documentId: [""],
      iconId: [""],
    });
  }


  getFormValue() {
    let request = new ProductServiceRequest();
    request.index = this.formBuilder.controls['index'].value;
    request.type = this.formBuilder.controls['type'].value;
    request.serviceName = this.formBuilder.controls['serviceName'].value;
    request.analyticsCode = this.formBuilder.controls['analyticsCode'].value;
    request.serviceDescription = this.serviceDescriptionValue;
    request.startTime = this.formBuilder.controls['startTime'].value;
    request.startDay = this.formBuilder.controls['startDay'].value;
    request.expirationDay = this.formBuilder.controls['expirationDay'].value;
    request.expirationTime = this.formBuilder.controls['expirationTime'].value;
    request.landingPageType = null;
    if (this.formBuilder.controls['landingPageType'].value != "") {
      request.landingPageType = this.formBuilder.controls['landingPageType'].value;
    }
    request.landingPageService = this.formBuilder.controls['landingPageService'].value;
    request.dataSheet = this.dataSheetValue;
    request.offerInformation = this.offerInformationValue;
    request.urlBookAndCollect = this.formBuilder.controls['urlBookAndCollect'].value;

    request.urlClickAndCollectType = null;
    if (this.formBuilder.controls['urlClickAndCollectType'].value != "") {
      request.urlClickAndCollectType = this.formBuilder.controls['urlClickAndCollectType'].value;
    }

    request.legalNotice = this.legalNoticeValue;
    let documents = this.getDocuments();
    if (documents != null) {
      request.documentId = documents[0];
    }
    request.iconId = this.formBuilder.controls['iconId'].value;
    return request;
  }

  save() {
    this.request = this.getFormValue();
    this.productServiceService.create(this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.toastr.success('Prodotto/Servizio salvato con successo', 'Salva Prodotto/Servizio', {
            timeOut: 5000
          });
          this.router.navigate([this.goBackUrl]);
        }
        this.isButtonSaveDisabled = false;
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la creazione della prodotto/servizio', 'Crea prodotto/servizio', {
          timeOut: 5000
        });
        this.isButtonSaveDisabled = false;
        this.spinner.hide();
      }
    );
  }


  /**
   * Azione click su button Carica da PC
   */
  openLoadImageFromPC() {
    //Apre modale di create
    const modalRef = this.modalService.open(ImmaginiCreateComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result) {
        if (result != "CLOSE") {
          let id = result.id;
          if (this.formBuilder.controls['iconId'].value != parseInt(id)) {
            this.formBuilder.controls['iconId'].setValue(id);
            this.loadImage(this.formBuilder.controls['iconId'].value);
          }
        }
      }
    }, (error) => {
      console.log(error);
    });
  }



  /**
   * Azione click su button carica da D.A.M
   */
  openLoadImageFromDAM() {
    //Apertura modale di modifica 
    let value = this.formBuilder.controls['iconId'].value;
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    if (value == "" || value == null) {
      value = [];
    } else {
      value = [value];
    }
    modalRef.componentInstance.multiple = false;
    modalRef.componentInstance.idImages = value;
    modalRef.result.then((result: any) => {
      if (result) {
        if (result.images.length > 0) {
          if (this.formBuilder.controls['iconId'].value != parseInt(result.images[0].id)) {
            this.formBuilder.controls['iconId'].setValue(result.images[0].id);
            this.loadImage(this.formBuilder.controls['iconId'].value);
          }
        } else {
          this.imageChoice = this.imageChoice = new ImageResponseGet();
          this.visibleImageChoice = false;
          this.formBuilder.controls['iconId'].setValue(null);
        }
      }
    }, (error) => {
      console.log(error);
    });
  }



  deleteImage() {
    this.imageChoice = new ImageResponseGet();
    this.visibleImageChoice = false;
    this.formBuilder.controls['iconId'].setValue(null);
  }


  loadImage(id) {
    this.visibleImageChoice = true;
    this.imageService.getEntity(id).subscribe(
      (response) => {
        this.insertImage(response);
      },
      (error) => {
        this.toastr.error('Si è verificato un errore durante il caricamento dell\'immagine', 'Caricamento immagine fallita', {
          timeOut: 5000
        });
      }
    );
  }

  insertImage(imageObj) {
    this.imageChoice = imageObj;
    let idImage = imageObj.id;
    if (imageObj.published === FALSE) {
      this.imageChoice.url = LOADINGIMAGE;
    }
    if (imageObj.published === FALSE) {
      this.downloadImage(idImage);
    }
  }
  /**
   * Carica immagine non pubblica
   * @param idImage 
   */
  downloadImage(idImage) {
    this.imageService.download(idImage).subscribe(
      (response) => {
        this.imageChoice.url = this.utilsService.getSecurityTrustURL(response);
      },
      (error: HttpErrorResponse) => {
        this.imageChoice.url = "/assets/images/no-image-icon.png";
      }
    );
  }




  /**
   * Azione click su button salva modifiche
   */
  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }


  /**
   * Azione click su button Annulla
   */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

  change() {
    this.form.markAsTouched();
  }

  //Autocomplete - documentIds  <- Documento
  @ViewChild('documentIds ') documentIds;
  documentIds_Keyword = 'name';
  documentIds_Suggestion: any = [];
  documentIds_Selected: any = [];
  documentIds_errorMsg: string;
  documentIds_isKeywordLoadingResult: boolean;
  getFilter_documentIds(event) {
    let request = new DocumentRequestSearch();
    request.name = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }
  fill_documentIds_Suggestion(response) {
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.documentIds_Selected.length && !trovato; j++) {
        if (obj.id == this.documentIds_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.documentIds_Suggestion.push(obj);
      }
    }
  }
  getList_documentIds(event) {
    this.change();
    this.documentIds_isKeywordLoadingResult = true;
    let request = this.getFilter_documentIds(event);
    this.documentService.search(request).subscribe(response => {
      this.documentIds_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        //aggiungo elementi nella suggestion
        this.fill_documentIds_Suggestion(response);
      }
      this.documentIds_isKeywordLoadingResult = false;
    });
  }
  searchCleared__documentIds() {
    this.change();

    this.documentIds_Suggestion = [];
    this.documentIds_Selected = [];
  }
  selectEvent__documentIds(item) {
    this.documentIds_Selected.push(item);
  }
  onFocused__documentIds(e) {
    console.log(e);
    this.getList_documentIds("");
    // do something when input is focused
  }

  getDocuments() {
    let res = null;
    if (this.documentIds_Selected.length > 0) {
      res = [];
      for (let obj of this.documentIds_Selected) {
        res.push(obj.id);
      }
    }
    return res;
  }
  setDocuments(value) {
    if (value != null) {
      this.documentIds_Selected = value;
    }
  }

}
